import actionTypes from './actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.LOAD_CONNECT_PARAMS:
            return {
                ...state,
                connectParams: {
                    ...payload
                }
            };
        case actionTypes.LOAD_GA_TRACKER:
            return {
                ...state,
                gaTracker: {
                    ...payload
                }
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/modules/configuration/reducers.js